export default __webpack_public_path__ + "static/media/BB_26.e153ecda.png";